
import { RANGER_SOURCE_MAP_METADATA } from './ranger-source-map.metadata';
import { RangerSourceMapBase } from './ranger-source-map.model.base';
import { CrudEntity, CrudEntityConstructionOptions } from '@scisys-uim/uim-common';

export interface RangerSourceMap extends RangerSourceMapBase {
}

export interface RangerSourceMapTransient { }

export class RangerSourceMap extends CrudEntity<RangerSourceMap, number, RangerSourceMapTransient> implements RangerSourceMapTransient {
  constructor(source?: Partial<RangerSourceMap>, options?: CrudEntityConstructionOptions<RangerSourceMap, number, RangerSourceMapTransient>) {
    super(RANGER_SOURCE_MAP_METADATA, source, options);
  }
  
  initialiseEntityDefaults() {
    super.initialiseEntityDefaults();
  }
  
  registerPropertyCalculators() {
    super.registerPropertyCalculators();
  }

  get email(): string {
    if (this.sourceExists && this.sourceEmail != null) {
      return this.sourceEmail;
    }
    if (this.rangerExists) {
      return this.rangerEmail;
    }
    return null;
  }
}

export const NON_EXISTING_RANGER_SOURCE: RangerSourceMap = new RangerSourceMap({
  sourceExists: false
});



